export const isDefined = <T>(value: T | null | undefined): value is T =>
  value !== null && value !== undefined;
export const isNotDefined = <T>(value: T | null | undefined): value is null | undefined =>
  value === null || value === undefined;

export const isFunction = <T extends AnyFunction>(value: T | any): value is T =>
  typeof value === 'function';
